import { axiosCanAuthorizedClassic, axiosClassic } from '../api/interceprots'

export const GroupService = {
	async getGroups(count = 4) {
		try {
			// Сначала пробуем отправить запрос с токеном
			const response = await axiosCanAuthorizedClassic.get(
				`groups?count=${count}&offset=0`
			)
			return response.data
		} catch (error) {
			// Если получаем ошибку 401 (Unauthorized), пробуем запрос без токена
			console.log('Unauthorized with token, trying without token')
			const publicResponse = await axiosClassic.get(`groups?count=${count}&offset=0`)
			return publicResponse.data
		}
	},
}
